import DataLoader from "dataloader"
import { useSuspenseQuery } from "@tanstack/react-query"
import { get } from "../typed-client/get"
import { GetStatusesRequest } from "../@client/Theasoft_ApiServer_CastStatus"

const loader = new DataLoader(
  async (keys: readonly number[]) => {
    const results = await get(
      "/api/CastStatus/GetCastStatuses",
      {
        ids: keys,
      } as GetStatusesRequest
    )
    return keys.map((key) => results.find((x) => x.castStatusId === key))
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedCastStatus(key: number) {
  return useSuspenseQuery({
    queryKey: ["BatchedStatus", key],
    queryFn: () => loader.load(key),
  })
}
